// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._33EPS{display:flex;height:56px;margin-bottom:10px}.eS6Hb{text-decoration:none}", "",{"version":3,"sources":["webpack://./src/desktop/components/RiddlesAdmin/PanelButtons/panelbuttons.scss"],"names":[],"mappings":"AAAA,QACE,YAAA,CACA,WAAA,CACA,kBAAA,CAGF,OACE,oBAAA","sourcesContent":[".wrap {\n  display: flex;\n  height: 56px;\n  margin-bottom: 10px;\n}\n\n.downloadButton {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "_33EPS",
	"downloadButton": "eS6Hb"
};
export default ___CSS_LOADER_EXPORT___;
